



















import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

/**
 * Composant de message centré.
 */
@Component
export default class CenteredMessage extends Vue {
	/** Propriétés */
	@Prop() icon!: string;
	@Prop() message!: string;
}
